<template>
  <div v-if="infoData">
    <div class="mb30">
      <button type="button"
        class="btn btnActivate"
        :class="{active: infoData.active}"
        @click="infoData.active = !infoData.active">
        {{locale.activate}}
      </button>
    </div>
    <div class="mb30">
      <p class="innerTitle setLabel">{{locale.app_id}}</p>
      <input type="text" class="input" v-model="infoData.appId" />
    </div>
    <div class="mb30">
      <p class="innerTitle setLabel">{{locale.app_secret}}</p>
      <input type="password" class="input" v-model="infoData.appSecret" />
    </div>
    <div v-if="accessToken" class="mb30 tokenMessage">
      {{locale.message_have_access_token}}
      <div class="mt10">
        <button type="button" class="link" @click="reAuth">{{locale.regenerate_access_token}}</button>
      </div>
    </div>
    <div v-if="authProcess">
      <div class="mb30">
        <p class="innerTitle setLabel">{{locale.auth_code}}</p>
        <button type="button" class="btn" :disabled="disabledMakeCode" @click="makeCode">
          <span v-if="infoData.code || accessToken">{{locale.regenerate}}</span>
          <span v-else>{{locale.generate}}</span>
        </button>
        <div v-if="disabledMakeCode" class="mt10 warnMessage">{{locale.message_generate_auth_code}}</div>
        <div v-else>
          <div v-if="infoData.code" class="mt10 tokenMessage">{{locale.message_generate_access_token}}</div>
          <div v-if="!infoData.code" class="mt10 warnMessage">{{locale.message_no_ahth_code}}</div>
        </div>
      </div>
      <div v-if="infoData.code" class="mb30">
        <p class="innerTitle setLabel">{{locale.generate_access_token}}</p>
        <button type="button" class="btn" @click="createAccessToken">{{locale.generate}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instagramfeed',
  props: [
    'locale',
    'infoData'
  ],
  computed: {
    disabledMakeCode () {
      const appId = this.infoData.appId
      const appSecret = this.infoData.appSecret
      return !(appId && appSecret)
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      accessToken: null,
      authProcess: true
    }
  },
  methods: {
    init () {
      const code = this.$route.params.code
      this.$store.dispatch('thirdparty/getAccessToken', { sns: 'instagram' }).then((res) => {
        if (res) {
          this.accessToken = res.access_token
          this.authProcess = code || !res.access_token
        }
      })
    },
    reAuth () {
      // '이미 액세스토큰이 있습니다.\n다시 토큰을 생성하기 위해서 인증과정을 거쳐야 합니다.\n계속 진행하시겠습니까?'
      if (window.confirm(`${this.locale.confirm_access_token_already}\n${this.locale.confirm_auth_code}\n${this.locale.confirm_proceed}`)) {
        this.authProcess = true
      }
    },
    // 토큰 생성에 필요한 코드 생성
    makeCode () {
      this.$emit('semiSave', () => this.makeInstagramCode())
    },
    makeInstagramCode () {
      const appId = this.infoData.appId
      const redirectUri = this.$store.getters['thirdparty/getInstagramRedirctUri']
      const getCode = `https://api.instagram.com/oauth/authorize
?client_id=${appId}
&redirect_uri=${redirectUri}
&scope=user_profile,user_media
&response_type=code`
      window.location.href = getCode
    },
    createAccessToken () {
      const data = {
        sns: 'instagram',
        appId: this.infoData.appId,
        appSecret: this.infoData.appSecret,
        code: this.infoData.code
      }
      this.$store.commit('onLoading', true)
      this.$store.dispatch('thirdparty/createAccessToken', data).then((res) => {
        if (res && res.access_token) {
          alert(this.locale.access_token_complete)
          this.$router.push({
            name: 'thirdparty',
            params: {
              id: 'instagramfeed'
            }
          })
          this.init()
        } else {
          if (res && res.message && res.message.includes('used')) {
            // '이미 사용된 인증코드입니다.\n인증코드를 새로받아 다시 액세스토큰을 생성해야합니다.'
            alert(`${this.locale.alert_auth_code_used}\n${this.locale.alert_regenerate_auth_code}`)
          } else {
            // '액세스토큰 생성에 실패했습니다.'
            alert(this.locale.alert_access_token_fail)
          }
        }
        this.$store.commit('onLoading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn.btnActivate {
  border-color: $color-lgrey;
  background-color: $color-lgrey;
  &.active {
    border-color: $color-primary;
    background-color: $color-primary;
  }
}
.tokenMessage {
  position: relative;
  padding-left: 26px;
  &:before {
    content: "";
    position: absolute;
    top: -1px;
    left: 0;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    border-radius: 100%;
    background: $color-green url('~@/assets/img/ico_checked.svg') 50% 50% / 12px no-repeat;
  }
  .link {
    text-decoration: underline;
  }
}
.warnMessage {
  position: relative;
  padding-left: 26px;
  &:before {
    content: "";
    position: absolute;
    top: -1px;
    left: 0;
    width: 20px;
    height: 20px;
    background: url('~@/assets/img/ico_warning.svg') 50% 50% / contain no-repeat;
  }
}
</style>
